import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDiaryEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={220} height={200} fill="none" {...props}>
    <g clipPath="url(#diaryEmpty_svg__a)">
      <path
        fill="#fff"
        d="M193.663 101.406c0 46.809-25.139 78.281-70.863 78.281s-96.024-19.729-96.024-66.538 31.866-92.542 77.59-92.542 89.297 33.99 89.297 80.799"
      />
      <path
        fill="#BFD1E3"
        d="M69.48 196.89C7.199 173.279 7.57 115.049 2.02 99.592c21.572-2.019 75.407 21.929 79.52 88.41z"
      />
      <path fill="#F1F5F9" d="m76.99 196.116-60.68-82.524 3.399 1.942 60.445 75.242z" />
      <path
        fill="#BFD1E3"
        d="M163.776 0c-3.999 0-6.689 2.047-6.689 5.771s1.686 7.82 5.686 7.82 7.907-2.594 7.907-6.319S167.775 0 163.776 0"
      />
      <path
        fill="#F1F5F9"
        d="M184.55 19.417c-7.713 0-12.899 3.949-12.899 11.131s3.251 15.083 10.964 15.083 15.249-5.005 15.249-12.187c0-7.183-5.601-14.027-13.314-14.027"
      />
      <path
        fill="#BFD1E3"
        d="M28.376 20.607c-11.2 0-18.73 5.88-18.73 16.576s4.72 22.462 15.92 22.462 22.142-7.454 22.142-18.15-8.132-20.888-19.332-20.888"
      />
      <rect width={104.426} height={137.609} x={57.776} y={61.334} fill="#6994BF" rx={6.832} />
      <path
        fill="#fff"
        d="M64.604 68.163 156.83 66.7l.976 127.968s-84.42 1.345-95.643-2.558c0-5.93 2.44-123.946 2.44-123.946"
      />
      <rect width={47.821} height={11.711} x={86.076} y={59.381} fill="#6994BF" rx={1.952} />
      <path
        fill="#BFD1E3"
        d="M77.776 85.717c0-.533.429-.968.962-.975l65.842-.94a.976.976 0 0 1 .874 1.439l-1.56 2.904a.98.98 0 0 1-.86.514H78.752a.976.976 0 0 1-.976-.976zM77.776 98.433c0 .534.429.968.962.976l65.221.945a.975.975 0 0 0 .978-1.127l-.456-2.91a.98.98 0 0 0-.964-.826H78.752a.976.976 0 0 0-.976.976zM77.776 110.144c0 .534.429.968.962.976l65.221.945a.975.975 0 0 0 .978-1.127l-.456-2.911a.98.98 0 0 0-.964-.825H78.752a.976.976 0 0 0-.976.976z"
      />
      <path
        fill="#BFD1E3"
        d="M133.461 156.975a71 71 0 0 1-1.691-.893c-1.139-.622-1.615-1.835-1.383-3.112 11.388-62.482 69.18-102.887 87.944-91.188.401 29.809-43.742 64.71-55.434 76.779a80 80 0 0 1-3.869 3.726c-.824.744-6.572-3.159-6.796-2.967-.223.193 4.248 5.179 3.884 5.481-7.146 5.906-14.595 10.26-19.289 12.312-1.083.474-2.315.402-3.366-.138"
      />
      <path
        fill="#6994BF"
        d="M123.947 166.373c9.999-24.036 55.421-89.963 93.346-104.393-39.729 18.285-80.013 83.325-89.042 105.708-3.796 9.41-8.45 16.853-8.813 16.726-.284-.099.641-8.744 4.509-18.041"
      />
    </g>
    <defs>
      <clipPath id="diaryEmpty_svg__a">
        <path fill="#fff" d="M.776 0h218.447v200H.776z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDiaryEmpty;
